import { render, staticRenderFns } from "./MPopupLaunchWebsite.vue?vue&type=template&id=65ee35b2&"
import script from "./MPopupLaunchWebsite.vue?vue&type=script&lang=ts&"
export * from "./MPopupLaunchWebsite.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports